(function(){
  function escapeHTML(str){ return String(str || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch])); }
  function decodeHTML(str){ const t=document.createElement('textarea'); t.innerHTML=String(str||''); return t.value; }
  function stripHTML(str){
    const without = String(str || '').replace(/<br\s*\/?\s*>/gi,' ').replace(/<\/p>/gi,' ').replace(/<[^>]*>/g,' ');
    return decodeHTML(without).replace(/https?:\/\/[^\s]+/g,'').replace(/\s+/g,' ').trim();
  }
  function trimText(str,max){ const s=stripHTML(str); return s.length>max ? s.slice(0,max-1).trim()+'…' : s; }
  function findUrls(text){ return ((text||'').match(/https?:\/\/[^\s<>\)\]"]+/gi)||[]).map(u=>u.replace(/[.,;]+$/,'')).filter(Boolean); }
  function domainFromUrl(url){ try { return new URL(url).hostname.replace(/^www\./,''); } catch(e){ return ''; } }
  function parseDate(value){
    if(!value) return null;
    if(value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const raw=String(value).trim();
    if(!raw) return null;
    if(/^\d{8}$/.test(raw)) return new Date(Number(raw.slice(0,4)), Number(raw.slice(4,6))-1, Number(raw.slice(6,8)));
    if(/^\d{8}T\d{6}Z?$/.test(raw)){
      const y=raw.slice(0,4), m=raw.slice(4,6), d=raw.slice(6,8), hh=raw.slice(9,11), mm=raw.slice(11,13), ss=raw.slice(13,15);
      return raw.endsWith('Z') ? new Date(`${y}-${m}-${d}T${hh}:${mm}:${ss}Z`) : new Date(`${y}-${m}-${d}T${hh}:${mm}:${ss}`);
    }
    const parsed=new Date(raw);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  function normalizeEvent(item){
    item = item || {};
    const start = parseDate(item.start || item.start_time || item.startDate || item.start_date || item.date || '');
    const end = parseDate(item.end || item.end_time || item.endDate || item.end_date || '');
    return {
      title: item.title || item.summary || item.name || '',
      description: item.description || item.notes || item.copy || '',
      location: item.location || '',
      start: start,
      end: end,
      url: item.url || item.link || item.htmlLink || '',
      image: item.image || item.image_url || item.thumbnail || '',
      allDay: item.all_day === true || item.allDay === true
    };
  }
  function unfoldICS(text){ return String(text || '').replace(/\r\n[ \t]/g,'').replace(/\n[ \t]/g,''); }
  function icsProp(block,name){
    const re = new RegExp('^' + name + '(?:;[^:]*)?:(.*)$','mi');
    const m = block.match(re);
    return m ? decodeHTML(m[1].replace(/\\n/g,' ').replace(/\\,/g,',').replace(/\\;/g,';').trim()) : '';
  }
  function parseICS(text){
    return unfoldICS(text).split('BEGIN:VEVENT').slice(1).map(part=>{
      const block='BEGIN:VEVENT'+part.split('END:VEVENT')[0];
      return normalizeEvent({title:icsProp(block,'SUMMARY'), description:icsProp(block,'DESCRIPTION'), location:icsProp(block,'LOCATION'), start:icsProp(block,'DTSTART'), end:icsProp(block,'DTEND'), url:(findUrls(icsProp(block,'DESCRIPTION'))[0]||'')});
    }).filter(e=>e.title && e.start);
  }
  function isCSW(evt){
    const hay=((evt.title||'')+' '+(evt.description||'')+' '+(evt.location||'')).toLowerCase();
    return hay.includes('casual swinger week') || hay.includes('csw 2027') || (hay.includes('hedonism') && hay.includes('march'));
  }
  function eventUrl(evt){
    if(evt.url) return evt.url;
    const urls=findUrls((evt.description||'')+' '+(evt.location||''));
    if(urls.length) return urls[0];
    if(isCSW(evt)) return '/pages/csw';
    return '';
  }
  function sourceLabel(evt){
    if(isCSW(evt)) return 'Casual Swinger Week';
    const url=eventUrl(evt);
    if(url) return domainFromUrl(url) || 'Upcoming Event';
    return 'Upcoming Event';
  }
  function adjustedEnd(end){
    if(!end) return null;
    const e=new Date(end.getTime());
    if(e.getHours()===0 && e.getMinutes()===0 && e.getSeconds()===0) return new Date(e.getTime()-1);
    return e;
  }
  function formatDateRange(start,end){
    if(!start) return 'Date coming soon';
    const opts={month:'short', day:'numeric', year:'numeric'};
    const e=adjustedEnd(end);
    if(e && start.toDateString() !== e.toDateString()){
      const sameYear=start.getFullYear()===e.getFullYear();
      const sameMonth=sameYear && start.getMonth()===e.getMonth();
      if(sameMonth) return `${start.toLocaleDateString(undefined,{month:'short'})} ${start.getDate()}-${e.getDate()}, ${start.getFullYear()}`;
      return `${start.toLocaleDateString(undefined,opts)} - ${e.toLocaleDateString(undefined,opts)}`;
    }
    return start.toLocaleDateString(undefined,opts);
  }
  function mediaHTML(evt, stage){
    const url=eventUrl(evt);
    const domain=url ? domainFromUrl(url) : '';
    if(evt.image) return `<div class="pn-event-card__media"><img src="${escapeHTML(evt.image)}" alt="${escapeHTML(evt.title)}" loading="lazy" onerror="this.onerror=null;this.src='${escapeHTML(stage.dataset.placeholderImage || '')}';this.parentElement.classList.add('pn-event-card__media--placeholder');"></div>`;
    if(isCSW(evt) && stage.dataset.cswImage) return `<div class="pn-event-card__media"><img src="${escapeHTML(stage.dataset.cswImage)}" alt="${escapeHTML(evt.title)}" loading="lazy"></div>`;
    if(domain){
      const fav='https://www.google.com/s2/favicons?sz=128&domain_url='+encodeURIComponent(url);
      return `<div class="pn-event-card__media pn-event-card__media--website"><div class="pn-event-domain-art"><img src="${fav}" alt="" loading="lazy"><span>${escapeHTML(domain)}</span></div></div>`;
    }
    return `<div class="pn-event-card__media pn-event-card__media--placeholder"><img src="${escapeHTML(stage.dataset.placeholderImage || '')}" alt="Casual Swinger calendar placeholder" loading="lazy"></div>`;
  }
  function cardHTML(evt, stage, kicker){
    const url=eventUrl(evt);
    const desc=trimText(evt.description || evt.location || 'More details coming soon.', 135);
    return `<article class="pn-event-card pn-event-card--dynamic ${isCSW(evt)?'pn-event-card--csw':''}">${mediaHTML(evt,stage)}<div class="pn-event-card__content"><p class="pn-card-kicker">${escapeHTML(kicker || sourceLabel(evt))}</p><h3>${escapeHTML(evt.title)}</h3><p class="pn-event-card__date">${escapeHTML(formatDateRange(evt.start, evt.end))}</p>${desc ? `<p>${escapeHTML(desc)}</p>` : ''}${url ? `<a class="pn-text-link" href="${escapeHTML(url)}">Details</a>` : ''}</div></article>`;
  }
  function detailHTML(evt, stage){
    if(!evt) return '<p class="pn-card-kicker">No event selected</p><h3>Pick a date with an event.</h3><p>Event details will open here.</p>';
    const url=eventUrl(evt);
    const desc=trimText(evt.description || evt.location || 'More details coming soon.', 260);
    return `${mediaHTML(evt,stage)}<div class="pn-month-calendar__detail-copy"><p class="pn-card-kicker">${escapeHTML(sourceLabel(evt))}</p><h3>${escapeHTML(evt.title)}</h3><p class="pn-event-card__date">${escapeHTML(formatDateRange(evt.start, evt.end))}</p>${evt.location ? `<p><strong>Location:</strong> ${escapeHTML(stripHTML(evt.location))}</p>` : ''}${desc ? `<p>${escapeHTML(desc)}</p>` : ''}${url ? `<a class="pn-button pn-button--secondary" href="${escapeHTML(url)}">View Details</a>` : ''}</div>`;
  }
  function featuredHTML(stage){ const tmpl=stage.querySelector('[data-calendar-featured-template]'); return tmpl ? tmpl.innerHTML.trim() : ''; }
  function fallbackEvents(stage){
    const title=(stage.dataset.fallbackTitle || 'Casual Swinger Week 2027').trim();
    const start=parseDate(stage.dataset.fallbackDate || '2027-03-13');
    const end=parseDate(stage.dataset.fallbackEnd || '2027-03-20');
    const copy=(stage.dataset.fallbackCopy || 'The signature hosted lifestyle travel week at Hedonism II in Negril, Jamaica.').trim();
    const url=(stage.dataset.fallbackUrl || '/pages/csw').trim();
    return start ? [normalizeEvent({title:title, description:copy, start:start, end:end, url:url, image:stage.dataset.cswImage || ''})] : [];
  }
  async function fetchEvents(stage, limit, showPast){
    let endpoint=(stage.dataset.calendarProxy || '').trim() || 'https://djcazual.com/calendar-feed-v12.php';
    if(/calendar-feed(?:-live)?\.php(?:$|[?#])/i.test(endpoint)) endpoint='https://djcazual.com/calendar-feed-v12.php';
    const url=new URL(endpoint, window.location.href);
    url.searchParams.set('limit', String(limit));
    if(showPast) url.searchParams.set('past','1');
    const res=await fetch(url.toString(), {credentials:'omit', mode:'cors', cache:'no-store'});
    if(!res.ok) throw new Error('calendar endpoint HTTP '+res.status);
    const text=await res.text();
    const trimmed=(text||'').trim();
    if(trimmed.indexOf('BEGIN:VEVENT') !== -1) return parseICS(trimmed);
    const data=JSON.parse(trimmed);
    if(data && data.ok === false) throw new Error(data.error || 'calendar endpoint ok=false');
    const raw=Array.isArray(data) ? data : (data.events || data.items || data.data || []);
    return raw.map(normalizeEvent).filter(e=>e.title && e.start);
  }
  function fillWithFeatured(arr, featured, total){ while(arr.length < total && featured) arr.push(featured); return arr; }
  function setGrid(grid, html){ if(!grid) return; grid.innerHTML=html; grid.hidden=false; grid.removeAttribute('hidden'); grid.style.display='grid'; }
  function setSlot(slot, html){ if(!slot) return; slot.innerHTML=html; slot.hidden=false; slot.removeAttribute('hidden'); slot.style.display='block'; }
  function sameDay(a,b){ return a && b && a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate(); }
  function eventTouchesDay(evt, day){
    const start=new Date(evt.start.getFullYear(), evt.start.getMonth(), evt.start.getDate());
    const end=adjustedEnd(evt.end) || evt.start;
    const eDay=new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const d=new Date(day.getFullYear(), day.getMonth(), day.getDate());
    return d >= start && d <= eDay;
  }
  function renderMonthCalendar(stage, events){
    const app=stage.querySelector('[data-calendar-month-app]');
    if(!app) return;
    const grid=stage.querySelector('[data-calendar-month-grid]');
    const title=stage.querySelector('[data-calendar-month-title]');
    const detail=stage.querySelector('[data-calendar-detail]');
    const prev=stage.querySelector('[data-calendar-prev]');
    const next=stage.querySelector('[data-calendar-next-month]');
    const today=new Date(); today.setHours(0,0,0,0);
    let cursor=new Date(today.getFullYear(), today.getMonth(), 1);
    let selectedDate=null;
    let selectedEvent=null;
    const sortedEvents=(events||[]).slice().sort((a,b)=>a.start-b.start);
    const nextUpcoming=sortedEvents.find(evt=>adjustedEnd(evt.end || evt.start) >= today) || sortedEvents[0] || null;
    function noEventHTML(day){
      const dayText=day ? day.toLocaleDateString(undefined,{weekday:'long', month:'long', day:'numeric', year:'numeric'}) : 'this day';
      const nextBlock=nextUpcoming ? `<div class="pn-month-calendar__next-mini"><p class="pn-card-kicker">Next up</p><h4>${escapeHTML(nextUpcoming.title)}</h4><p class="pn-event-card__date">${escapeHTML(formatDateRange(nextUpcoming.start, nextUpcoming.end))}</p></div>` : '';
      return `<p class="pn-card-kicker">${escapeHTML(dayText)}</p><h3>Nothing scheduled this day.</h3><p>Tap another date, or check the next upcoming event below.</p>${nextBlock}`;
    }
    function choose(evt, day){
      selectedEvent=evt || null;
      selectedDate=day || (evt ? evt.start : selectedDate);
      if(detail) detail.innerHTML = evt ? detailHTML(evt, stage) : noEventHTML(selectedDate);
      if(grid) grid.querySelectorAll('.pn-month-calendar__day').forEach(cell=>{
        const ds=cell.getAttribute('data-day');
        cell.classList.toggle('is-selected', !!selectedDate && ds === selectedDate.toISOString().slice(0,10));
      });
    }
    function paint(){
      const monthStart=new Date(cursor.getFullYear(), cursor.getMonth(), 1);
      const monthEnd=new Date(cursor.getFullYear(), cursor.getMonth()+1, 0);
      const start=new Date(monthStart); start.setDate(start.getDate()-start.getDay());
      const end=new Date(monthEnd); end.setDate(end.getDate()+(6-end.getDay()));
      if(title) title.textContent=monthStart.toLocaleDateString(undefined,{month:'long', year:'numeric'});
      let html='';
      for(let d=new Date(start); d<=end; d.setDate(d.getDate()+1)){
        const day=new Date(d); day.setHours(0,0,0,0);
        const iso=day.toISOString().slice(0,10);
        const inMonth=day.getMonth()===cursor.getMonth();
        const allDayEvents=events.filter(evt=>eventTouchesDay(evt, day));
        const dayEvents=allDayEvents.slice(0,3);
        const moreCount=Math.max(0, allDayEvents.length - dayEvents.length);
        html += `<div class="pn-month-calendar__day ${inMonth?'':'is-muted'} ${sameDay(day,today)?'is-today':''}" data-day="${iso}"><button type="button" class="pn-month-calendar__empty-day" data-day-select="${iso}" aria-label="Select ${iso}"><span class="pn-month-calendar__date">${day.getDate()}</span></button><div class="pn-month-calendar__events">`;
        dayEvents.forEach((evt)=>{ html += `<button type="button" class="pn-month-calendar__event" data-event-index="${events.indexOf(evt)}" data-day-select="${iso}"><span>${escapeHTML(evt.title)}</span></button>`; });
        if(moreCount) html += `<span class="pn-month-calendar__more">+${moreCount} more</span>`;
        html += '</div></div>';
      }
      if(grid) grid.innerHTML=html;
      const monthEvents=events.filter(evt=>evt.start.getFullYear()===cursor.getFullYear() && evt.start.getMonth()===cursor.getMonth()).sort((a,b)=>a.start-b.start);
      const defaultEvent=monthEvents.find(evt=>evt.start>=today) || nextUpcoming || monthEvents[0] || null;
      choose(defaultEvent, defaultEvent ? new Date(defaultEvent.start.getFullYear(), defaultEvent.start.getMonth(), defaultEvent.start.getDate()) : null);
    }
    if(grid){
      grid.addEventListener('mouseover', function(e){ const btn=e.target.closest('[data-event-index]'); if(btn){ const evt=events[Number(btn.dataset.eventIndex)]; choose(evt, new Date(evt.start.getFullYear(), evt.start.getMonth(), evt.start.getDate())); } });
      grid.addEventListener('focusin', function(e){ const btn=e.target.closest('[data-event-index]'); if(btn){ const evt=events[Number(btn.dataset.eventIndex)]; choose(evt, new Date(evt.start.getFullYear(), evt.start.getMonth(), evt.start.getDate())); } });
      grid.addEventListener('click', function(e){
        const eventBtn=e.target.closest('[data-event-index]');
        if(eventBtn){ const evt=events[Number(eventBtn.dataset.eventIndex)]; choose(evt, new Date(evt.start.getFullYear(), evt.start.getMonth(), evt.start.getDate())); return; }
        const dayBtn=e.target.closest('[data-day-select]');
        if(dayBtn){
          const parts=String(dayBtn.dataset.daySelect || '').split('-').map(Number);
          if(parts.length===3){
            const day=new Date(parts[0], parts[1]-1, parts[2]);
            const firstEvent=events.filter(evt=>eventTouchesDay(evt, day)).sort((a,b)=>a.start-b.start)[0] || null;
            choose(firstEvent, day);
          }
        }
      });
    }
    if(prev) prev.addEventListener('click', function(){ cursor=new Date(cursor.getFullYear(), cursor.getMonth()-1, 1); paint(); });
    if(next) next.addEventListener('click', function(){ cursor=new Date(cursor.getFullYear(), cursor.getMonth()+1, 1); paint(); });
    app.hidden=false; app.removeAttribute('hidden');
    paint();
  }
  async function initOne(stage){
    if(stage.dataset.calendarInitialized === 'true') return;
    stage.dataset.calendarInitialized = 'true';
    const grid=stage.querySelector('[data-calendar-grid]');
    const next=stage.querySelector('[data-calendar-next]');
    const status=stage.querySelector('[data-calendar-status]');
    const mode=stage.dataset.mode || 'home';
    const isHome=mode !== 'full';
    const limit=isHome ? 4 : Math.max(24, parseInt(stage.dataset.limit || '24', 10));
    const showPast=stage.dataset.showPast === 'true';
    const featured=featuredHTML(stage);
    try{
      let events=await fetchEvents(stage, limit, showPast);
      const today=new Date(); today.setHours(0,0,0,0);
      events=events.filter(evt=>showPast || !evt.end || adjustedEnd(evt.end) >= today).sort((a,b)=>a.start-b.start);
      if(!events.length) throw new Error('No upcoming events');
      if(isHome){
        setSlot(next, cardHTML(events[0], stage, 'Next Event'));
        const lower=events.slice(1,4).map(evt=>cardHTML(evt, stage));
        setGrid(grid, fillWithFeatured(lower, featured, 3).join(''));
      }else{
        setSlot(next, '');
        if(next) next.style.display='none';
        if(grid){ grid.innerHTML=''; grid.hidden=true; grid.style.display='none'; }
        renderMonthCalendar(stage, events);
      }
      if(status){ status.hidden=true; status.style.display='none'; }
    }catch(err){
      console.warn('[CasualSwinger calendar] live feed failed, keeping/filling featured cards', err);
      if(isHome){
        setSlot(next, featured || (next ? next.innerHTML : ''));
        setGrid(grid, fillWithFeatured([], featured, 3).join(''));
      }else{
        if(next) next.style.display='none';
        if(grid){ grid.innerHTML=''; grid.hidden=true; grid.style.display='none'; }
        renderMonthCalendar(stage, fallbackEvents(stage));
      }
      if(status){ status.hidden=true; status.style.display='none'; }
    }
  }
  function init(){ document.querySelectorAll('[data-calendar-events]').forEach(initOne); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(){ document.querySelectorAll('[data-calendar-events]').forEach(el=>{ delete el.dataset.calendarInitialized; }); init(); });
})();
